/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Moon = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.4434 16.7814C17.8703 19.023 15.2353 20.5 12.2396 20.5C7.3899 20.5 3.5 16.6379 3.5 11.9246C3.5 8.51039 5.53978 5.54348 8.50873 4.16675C8.47918 4.50985 8.4641 4.85704 8.4641 5.20762C8.4641 11.477 13.307 16.6753 19.4434 16.7814ZM20.2938 15.26C20.076 15.2753 19.8563 15.283 19.6348 15.283C14.2938 15.283 9.9641 10.7721 9.9641 5.20762C9.9641 4.66443 10.0054 4.13127 10.0848 3.61137C10.1987 2.86605 9.57374 2.16544 8.86074 2.41058C8.83597 2.4191 8.81124 2.42771 8.78655 2.43641C4.83035 3.83055 2 7.55233 2 11.9246C2 17.4891 6.58441 22 12.2396 22C16.1559 22 19.5588 19.8366 21.2811 16.658C21.2965 16.6296 21.3117 16.6011 21.3269 16.5726C21.6774 15.9104 21.0412 15.2076 20.2938 15.26Z"
                        fill={color}
                    />
                </svg>
        );
    };
